// bump this before native release
const buildNumber = 1;

module.exports = {
  name: "Teamworks - Digital Displays",
  slug: "teamworks-tv",
  owner: "kairos-team",
  version: `${buildNumber}.7.6`,
  runtimeVersion: String(buildNumber),
  orientation: "portrait",
  icon: "./assets/icon.png",
  userInterfaceStyle: "dark",
  splash: {
    image: "./assets/splash.png",
    resizeMode: "contain",
    backgroundColor: "#000000",
  },
  assetBundlePatterns: ["**/*"],
  updates: {
    url: "https://u.expo.dev/20befbe6-448a-4e26-a645-707cec7c026f",
  },
  plugins: [
    [
      "@react-native-tvos/config-tv",
      {
        showVerboseWarnings: true,
      },
    ],
    [
      "@sentry/react-native/expo",
      {
        organization: "kairos-sports-tech",
        project: "tv-app",
      },
    ],
  ],
  ios: {
    supportsTablet: true,
    bundleIdentifier: "com.teamworks.tv",
    buildNumber: String(buildNumber),
  },
  android: {
    adaptiveIcon: {
      foregroundImage: "./assets/adaptive-icon.png",
      backgroundColor: "#000000",
    },
    package: "com.teamworks.tv",
    versionCode: buildNumber,
  },
  web: {
    output: "single",
    bundler: "metro",
    favicon: "./assets/favicon.png",
  },
  extra: {
    eas: {
      projectId: "20befbe6-448a-4e26-a645-707cec7c026f",
    },
  },
};
